<div class="yellowMask">

    <div class="headerContainer">
        <div id="headerLogo"></div>
        <button class="headerButton btn-yellow-white" (click)="fwHilfe()"><span class="hilfe"></span></button>
        <button class="headerButton btn-yellow-white" (click)="fwKautionsPage()"><span>Zur Kautions-Produktseite</span></button>
    </div>

    <div class="contentContainer">
        <h1>{{ headline }}</h1>
    </div>

    <extern-footer class="pageYellow"></extern-footer>

</div>
